<template>
  <div class="container h-100">
    <div class="h-100 row align-items-center justify-content-center">
      <div class="col-10 pt-5">
        <img
          src="@/assets/images/logos/logo-pse.png"
          width="100%"
          alt="Logo PSE"
        />
      </div>
      <div class="col-10 pb-5">
        <div class="w-100">
          <label :for="1" class=""
            ><h6 class="mt-1 mb-2 d-flex">
              NOMBRE
              <p class="subtext m-0 ml-2">
                (DEBE COINCIDIR CON PSE)
              </p>
            </h6>
          </label>
          <input class="w-100" v-model="formName" />
        </div>
        <div class="w-100">
          <label :for="1" class=""
            ><h6 class="mt-1 mb-2 d-flex">
              EMAIL
              <p class="subtext m-0 ml-2">
                (DEBE COINCIDIR CON PSE)
              </p>
            </h6>
          </label>
          <input class="w-100" v-model="formEmail" />
        </div>
      </div>
      <div class="col-10">
        <!-- <button class="bg-accent">Continuar</button> -->
        <pay-u-button
          :selectedPlan="selectedPlan"
          :isRecharge="isRecharge"
          :buttonLabel="'Continuar'"
          :buttonClass="'bg-accent mt-3'"
          :formName="formName"
          :formEmail="formEmail"
          :isCash="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PayUButton from "@/components/UI/PayUButton"
export default {
  data() {
    return { formName: "", formEmail: "" }
  },
  components: { PayUButton },
  props: ["selectedPlan", "isRecharge"],
  methods: {},
}
</script>

<style lang="scss"></style>
